module.exports = __webpack_public_path__ + "assets/img/3套利.f339e0dc.png";